import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ScoreOutlined from '@mui/icons-material/ScoreOutlined';
import TooltipForButton from '@/components/mui/Tooltip/TooltipForButton';
import { useDocumentSubtypes } from '@/domain/documents/queries';

type Props = {
  // Writes a change-type tag carrying the chosen sub-type id.
  onChangeType: (type: string) => void;
};

const MARK_AS_FINANCIAL_TOOLTIP = {
  id: 'selectedPanel.generateJournalEntry',
  defaultMessage: 'Mark as financial document',
};

const BulkMarkAsFinancialMenu = ({ onChangeType }: Props) => {
  const popupState = usePopupState({ variant: 'popover', popupId: 'BulkMarkAsFinancial' });
  const { data: subtypes = [], isLoading } = useDocumentSubtypes();

  // Sub-type menu — all items enabled (a bulk selection can hold mixed current sub-types).
  const handleSelect = (subtypeId: string) => () => {
    popupState.close();
    onChangeType(subtypeId);
  };

  return (
    <>
      <TooltipForButton t={MARK_AS_FINANCIAL_TOOLTIP} placement="top">
        <IconButton
          aria-label="convertToFinancial"
          color="primary"
          disabled={isLoading || subtypes.length === 0}
          {...bindTrigger(popupState)}
        >
          <ScoreOutlined />
        </IconButton>
      </TooltipForButton>
      <Menu {...bindMenu(popupState)}>
        {subtypes.map((s) => (
          <MenuItem key={s.id} onClick={handleSelect(s.id)}>
            {s.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default BulkMarkAsFinancialMenu;
